import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear(); // Get the current year

  return (
    <div>
      {/* <!-- ======= Footer ======= --> */}
      <footer id="footer" className="footer">
        <div className="copyright">
          &copy; Copyright{' '}
          <strong>
            <span>2016-{currentYear} PRiNTF Technologies</span>
          </strong>
          . All Rights Reserved
        </div>
      </footer>
    </div>
  );
}
